module.exports = {"341125100":"定城镇","341125101":"炉桥镇","341125102":"永康镇","341125103":"吴圩镇","341125104":"朱湾镇","341125105":"张桥镇","341125106":"藕塘镇","341125107":"池河镇","341125108":"连江镇","341125109":"界牌集镇","341125110":"仓镇","341125111":"三和集镇","341125112":"西卅店镇","341125113":"桑涧镇","341125114":"蒋集镇","341125115":"大桥镇","341125200":"严桥乡","341125201":"拂晓乡","341125202":"能仁乡","341125203":"七里塘乡","341125204":"二龙回族乡","341125205":"范岗乡","341125400":"安徽定远经济开发区","341125401":"定远盐化工业园","341125402":"凌家湖农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341125.json
// module id = 1114
// module chunks = 0